import DBOperations from "src/utils/dbOperations";
import Exception from "src/utils/exception";
import Constants from "src/utils/constants";

const rpcNameStatusCounts =
  Constants.enums.DATABASE_FUNCTION_ENUM.GET_STATUS_COUNTS;
const rpcNameInspectionCounts =
  Constants.enums.DATABASE_FUNCTION_ENUM.GET_INSPECTION_COUNTS;
const rpcNameHighwayPins =
  Constants.enums.DATABASE_FUNCTION_ENUM.GET_HIGHWAY_PINS;
const rpcNameInspectionHighwayPins =
  Constants.enums.DATABASE_FUNCTION_ENUM.GET_INSPECTION_HIGHWAY_PINS;
async function getStatusCounts(formTemplateId, areaIds, regionID = null, dateRange = null) {
  try {
    if (formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM) {
      return await DBOperations.useSupabaseRPC(rpcNameStatusCounts, {
        p_form_template_id: formTemplateId,
        p_area_ids: areaIds,
        p_date_range: dateRange,
        p_region_id: regionID
      });
    } else if (
      formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM
    ) {
      return await DBOperations.useSupabaseRPC(rpcNameInspectionCounts, {
        p_form_template_id: formTemplateId,
        p_area_ids: areaIds,
        p_date_range: dateRange,
        p_region_id: regionID
      });
    }
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

async function getHighwayPins(
  formTemplateId,
  typeID = null,
  areaIds = null,
  highwayIDs = null,
  searchTxt = null,
  statuses = null,
  dateRange = null,
  regionID = null,
  priority = null
) {
  try {
    if (formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.DEFECTS_FORM) {
      return await DBOperations.useSupabaseRPC(rpcNameHighwayPins, {
        p_form_template_id: formTemplateId,
        p_defect_type_id: typeID,
        p_defect_area_ids: areaIds,
        p_defect_highway_ids: highwayIDs,
        p_defect_search_string: searchTxt,
        p_defect_statuses: statuses,
        p_date_range: dateRange,
        p_region_id: regionID,
        p_priority: priority
      });
    } else if (
      formTemplateId === Constants.enums.FORM_TEMPLATE_IDS.INSPECTION_FORM
    ) {
      return await DBOperations.useSupabaseRPC(rpcNameInspectionHighwayPins, {
        p_form_template_id: formTemplateId,
        p_inspection_type_id: typeID,
        p_inspection_area_ids: areaIds,
        p_inspection_highway_ids: highwayIDs,
        p_inspection_search_string: searchTxt,
        p_date_range: dateRange,
        p_region_id: regionID
      });
    }
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getStatusCounts,
  getHighwayPins
};
